import styled from "styled-components"
import ThriveLogo from "../assets/logos/thrive-logo.png"
import JaagoLogo from "../assets/logos/jaago-logo.png"
import DirectFreshLogo from "../assets/logos/direct-fresh-logo.png"
import { phoneWidth } from "../Globalstyle"

const StyledContainer = styled.div`
  height: 8rem;
  background-color: var(--light-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem var(--side-padding);

  @media (max-width: ${phoneWidth}) {
    height: 30rem;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

const Logos = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;

  @media (max-width: ${phoneWidth}) {
    height: 8rem;
    flex-direction: column;
  }
`

const LogoContainer = styled.a`
  display: block;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

const Logo = styled.img`
  height: 100%;
  object-fit: contain;
  filter: saturate(0) brightness(1.25);
`

const LogoRow = () => {
  return (
    <StyledContainer>
      <Logos>
        <LogoContainer href="https://www.jaago.com.bd/" target="_blank">
          <Logo src={JaagoLogo} alt="Jaago logo"/>
        </LogoContainer>
        <LogoContainer href="https://www.thrive-global.org/" target="_blank">
          <Logo src={ThriveLogo} alt="Thrive logo"/>
        </LogoContainer>
        <LogoContainer href="https://directfreshbd.com/" target="_blank">
          <Logo src={DirectFreshLogo} alt="Direct fresh logo"/>
        </LogoContainer>
      </Logos>
    </StyledContainer>
  )
}

export default LogoRow